module.exports = __webpack_public_path__ + "img/yuanbao_share.0d159ad8.png";